/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const UserRoundKey = [
  ["path", { d: "M19 11v6" }],
  ["path", { d: "M19 13h2" }],
  ["path", { d: "M2 21a8 8 0 0 1 12.868-6.349" }],
  ["circle", { cx: "10", cy: "8", r: "5" }],
  ["circle", { cx: "19", cy: "19", r: "2" }]
];

export { UserRoundKey as default };
//# sourceMappingURL=user-round-key.js.map
